export default [
  {
    path: "/organizations/:organizationId/users",
    props: true,
    component: () => import("@/views/reports/users/ListUsers.vue"),
    meta: {
      authorization: { roles: ["organization-administrator"] },
    },
  },
  {
    path: "/organizations/:organizationId/users/create",
    props: true,
    component: () => import("@/views/reports/users/CreateUser.vue"),
    meta: {
      authorization: { roles: ["organization-administrator"] },
    },
  },
  {
    path: "/organizations/:organizationId/users/:userId",
    props: true,
    component: () => import("@/views/reports/users/EditUser.vue"),
    redirect: to => to.path + "/profile",
    meta: {
      authorization: {
        policies: ["user"],
      },
    },
    children: [
      {
        path: "profile",
        props: true,
        component: () => import("@/views/reports/users/EditUserProfile.vue"),
        meta: {
          authorization: {
            policies: ["user"],
          },
        },
      },
      {
        path: "roles",
        props: true,
        component: () => import("@/views/reports/users/EditUserRoles.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
      {
        path: "regions",
        props: true,
        component: () => import("@/views/reports/users/EditUserRegions.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
      {
        path: "facilities",
        props: true,
        component: () => import("@/views/reports/users/EditUserFacilities.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
      {
        path: "functions",
        props: true,
        component: () => import("@/views/reports/users/EditUserFunctions.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
      {
        path: "companies",
        props: true,
        component: () => import("@/views/reports/users/EditUserCompanies.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
      {
        path: "interviews",
        props: true,
        component: () => import("@/views/reports/users/EditUserInterviews.vue"),
        meta: {
          authorization: { roles: ["organization-administrator"] },
        },
      },
    ],
  },
];
